import React, { FC } from 'react';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { CanGoBack } from '../../models/CanGoBack';
import { WizardSummaryLayout } from '../wizard/wizard-summary-layout';
import { SettingSummaryField } from '../settingFields/SettingSummaryField';

interface SummaryFormProps extends CanGoBack {
    categoryId?: number;
}
export const SummaryForm: FC<SummaryFormProps> = ({ categoryId = undefined, onBack }) => {
    const { translate } = useLocale();

    return <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.confirm)}>
            <div className="pb-3">
                <SettingSummaryField accessor={"displayName"} displayName={translate.byKey(TranslationKeys.displayName)}></SettingSummaryField>
            </div>
            <div className="pb-3">
                <SettingSummaryField accessor={"description"} displayName={translate.byKey(TranslationKeys.description)}></SettingSummaryField>
            </div>

            {categoryId
                ? null
                : <div className="pb-3">
                    <SettingSummaryField accessor={"copyOfName"} displayName={translate.byKey(TranslationKeys.copyOf)}></SettingSummaryField>
                </div>
            }
            {/* <div className="pb-3">
                <SettingSummaryField accessor={"singleOwner"} displayName={translate.byKey(TranslationKeys.singleOwner)}></SettingSummaryField>
            </div>
            <div className="pb-3">
                <SettingSummaryField accessor={"autoIdNumber"} displayName={translate.byKey(TranslationKeys.autoGenerateIdNumber)}></SettingSummaryField>
            </div> */}
            <div className="pb-3">
                <SettingSummaryField accessor={"fields"} displayName={translate.byKey(TranslationKeys.fields)}></SettingSummaryField>
            </div>
    </WizardSummaryLayout>;
};
